import {
  $document,
  $window,
  $htmlBody,
  $html,
  $body,
  $main,
  $footer
} from './Variables'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { show, hide, tweenX, tweenY } from './Toggle.js'

const scrollTo = (element, target, offsetY, options) => {
  function offClick() {
    return new Promise((resolve, reject) => {
      if (options.onResize == true) {
        $(element).off('click')
      }
      resolve()
    })
  }
  const onClick = () => {
    $(element).on('click', function() {
      TweenLite.to(window, 1, {
        scrollTo: {
          y: target,
          offsetY: offsetY,
          autoKill: false
        },
        ease: options.ease
      })
      return false
    })
  }
  offClick().then(onClick())
}

const getScrollBottom = () => {
  const body = window.document.body
  const html = window.document.documentElement
  const scrollTop = body.scrollTop || html.scrollTop
  return html.scrollHeight - html.clientHeight - scrollTop
}

class SmoothScroll {
  constructor(element, target, options) {
    this.element = element
    this.target = target
    this.options = options
  }
  /**
   * [scroll description]
   * @return {[type]} [description]
   */
  setScroll() {
    const target = this.target,
      options = this.options

    scrollTo(this.element, target, options)
  }
  toggle() {
    const target = this.target,
      options = this.options

    tweenY(this.element, options)
  }
}

export { scrollTo, getScrollBottom, SmoothScroll }
